/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfirmResetPasswordRequest
 */
export interface ConfirmResetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfirmResetPasswordRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmResetPasswordRequest
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof ConfirmResetPasswordRequest
     */
    password: string;
}

/**
 * Check if a given object implements the ConfirmResetPasswordRequest interface.
 */
export function instanceOfConfirmResetPasswordRequest(value: object): value is ConfirmResetPasswordRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function ConfirmResetPasswordRequestFromJSON(json: any): ConfirmResetPasswordRequest {
    return ConfirmResetPasswordRequestFromJSONTyped(json, false);
}

export function ConfirmResetPasswordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmResetPasswordRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'token': json['token'],
        'password': json['password'],
    };
}

export function ConfirmResetPasswordRequestToJSON(json: any): ConfirmResetPasswordRequest {
    return ConfirmResetPasswordRequestToJSONTyped(json, false);
}

export function ConfirmResetPasswordRequestToJSONTyped(value?: ConfirmResetPasswordRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'token': value['token'],
        'password': value['password'],
    };
}

